import lodashFind from "lodash/fp/find";
import type { AppRouteConfigView } from "shared/mappers/database/app-route/app-route-config/app-route-config";

export const findRoute = (
  routes: AppRouteConfigView[],
  criteria:
    | Partial<AppRouteConfigView>
    | ((route: AppRouteConfigView) => boolean),
) => {
  const flat = routes.flatMap((route) => {
    return [route, ...(route?.childrenAppRouteConfig ?? [])];
  });
  return lodashFind(criteria, flat);
};
